import { message } from 'antd';
import { config } from 'util/config';
import { httpClient, uploadClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}


export function addMultipleBlockDates({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showAddMultipleBlockDates: true });
}

export function submitBlockDatesForm({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  var form = pageComponent.blockDatesFormRef.current?.getFieldsValue();
  form.ModuleId = pageComponent.state.defaultFormData.moduleId;
  form.StartDate = pageComponent.blockDatesFormRef.current?.getFieldsValue().Date[0].format(config.format.sqlDate);
  form.EndDate = pageComponent.blockDatesFormRef.current?.getFieldsValue().Date[1].format(config.format.sqlDate);
  pageComponent.setState({ formSubmitting: true });
  httpClient
    .post('/Admin/SubJobBlockDates/AddBlockDates', form)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.blockDatesFormRef.current?.resetFields();
        setTimeout(() => {
          pageComponent.setState({ showAddMultipleBlockDates: false });
          pageComponent.createPage.current?.child[0].current.setState({ searchParameter: { moduleId: pageComponent.state.defaultFormData.moduleId } });
          pageComponent.createPage.current?.child[0].current.getSectionDataByDefault();
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
